module.exports = __webpack_public_path__ + "static/media/hero.12d87ed5.svg";